// extracted by mini-css-extract-plugin
export default {"head":"style_head__v35J-","actions":"style_actions__Uv-sU","titleRow":"style_titleRow__TH6K2","submenu":"style_submenu__MaOx4"};